(function ($, Drupal) {
  /**
   * Carousel functionality
   * Go to slide
   */
   Drupal.behaviors.kinaxisGoToSlide = {
    attach: function (context, settings) {
      $(document).on('click', '.slick-slide', function (e) {
        e.stopPropagation();
        var index = $(this).data("slick-index");
        var slider = $(this).parents('.slick-slider');
        if (slider.slick('slickCurrentSlide') !== index) {
          slider.slick('slickGoTo', index);
        }
      });
      var slickSlider = $('.slick-autoplay .slick__slider');
      if (slickSlider.length > 0) {
        slickSlider.not('.slick-initialized').slick({
          autoplay: true,
          autoplaySpeed: $('.slick-autoplay').data('auto-timer') * 1000,
        });
      }
    }
  };
})(jQuery, Drupal);
